import type { ProductItem, ProductRow, ProductsApi, ProductsResponse } from '../../models';

const toRow = ({ id, productCode, productDesc, productUnitMeasure }: ProductItem): ProductRow => ({
  id: String(id),
  productCode: productCode ?? '',
  productDesc: productDesc ?? '',
  productKey: id,
  productUnitMeasure: productUnitMeasure?.trim() ?? '',
});

export const normalizeProducts = (result: ProductsResponse | null): ProductsApi => {
  if (result === null) {
    return { data: [], total: 0 };
  }

  if (Array.isArray(result)) {
    return { data: result.map(toRow), total: result.length };
  }

  return {
    data: (result.items ?? []).map(toRow),
    total: result.totalCount,
  };
};
